export const isMobile = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(
    userAgent
  );

  const isMobileViewport = window.innerWidth <= 768;

  return isMobileUserAgent || isMobileViewport;
};

export const isIOS = (): boolean => /iPad|iPhone|iPod/.test(navigator.userAgent);
